import React from "react";
import WorkerProcessStatus from "../../models/WorkerProcessStatus";
import Field from "../Fields/Field";
import { LabelProps } from "../Fields/Types";
import ProgressBarControl from "./ProgressBarControl";

interface FieldProps {
    labelProps: LabelProps
    progress: WorkerProcessStatus
    visible: boolean
}

const ProgressBarField: React.FC<FieldProps> = ({ labelProps, progress, visible }) => {
    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <ProgressBarControl {...progress} />
        </Field>
    );
}
export default ProgressBarField;